
export class Visit {
    strips: StripVisit[] = [];
    total: Total;
}


export class Total {
    countOfVisits? :number = 0;
    services_sum?: number = 0;
    purchase_sum?: number = 0;
    total_sum?: number = 0;
    averageVisit?: number = 0;
    dateEvent: string; 
    showMoreButton?: boolean;
}


export class StripVisit {
    customerId: number;
    dateVisit: string;
    nameDay: string;
    hasInvoice?: number;
    numColor: number;
    is1900C?: boolean;
    isConfirmed?: boolean;
    sum_ServicesPerDay: number;
    sum_PurchasePerDay: number;
    total_payed: number;
    fromStr: string;
    min_fromTime: string;
    comments: string;
    isHaveComments?: boolean;
    countServices: number;
    servicesName: string;
    countPurchase: number;
    itemsName: string;
    isDeleted?: boolean;
    isCanceled?: boolean;
    cancelReasonByDate?: string;
    numFilter: number;
    dkey: string;
    substrips: SubStripVisit[] = [];    
}

export class SubStripVisit {
    customerId: number;
    id: number;
    dateVisit: string;
    fromTime: string;
    toTime: string;
    companyName: string;
    amount: string;
    saparName: string;
    workerImageName: string;
    clientPrice: string;
    pricePerchase: string;
    discountPrice: string;
    percentAmount: string;
    serviceNamestr: string;
    subStr: string;
    isDeleted?: boolean;
    isService?: number;
    sortOrd: number;
    numColor: number;
    dkey: string;
    saparId: number;
}

export class StripIn {
    customerId: number;
    numColor: number;
    dateVisit: string;
}